import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable()
export class PerfilesService {

  PEnombre;
  PEusuario;
  PEinterviniente;
  PEadmin;

  constructor(private http:HttpClient) { }


  getPerfiles(filtro){

    filtro.nombre==""?this.PEnombre="-":this.PEnombre=filtro.nombre;
    filtro.permisos=="limitado"?this.PEusuario=1:this.PEusuario="-";
    filtro.permisos=="interviniente"?this.PEinterviniente=1:this.PEinterviniente="-";
    filtro.permisos=="admin"?this.PEadmin=1:this.PEadmin="-";

    return this.http.get(`https://app.solucionlegal.es/API/index.php/Perfiles/perfiles/${this.PEnombre}/${this.PEusuario}/${this.PEinterviniente}/${this.PEadmin}`)
    .map(resp=>{
      return resp;
      
    });
  }

  getPerfil(codPerfil){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Perfiles/perfil/${codPerfil}`)
    .map(resp=>{
      return resp;
    });
  }

  insertarPerfil(perfil){
    let body=JSON.stringify(perfil);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Perfiles/insertPerfil`,body)
    .map(resp=>{
      return resp;
    });
  }

  actualizarPerfil(perfil){
    let body=JSON.stringify(perfil);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Perfiles/updatePerfil/${perfil.PEcodigo}`,body)
    .map(resp=>{
      return resp;
    });
  }

  borrarPerfil(codPerfil){
    return this.http.delete(`https://app.solucionlegal.es/API/index.php/Perfiles/perfil/${codPerfil}`)
    .map(resp=>{
      return resp;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/perfiles.service.ts